import {
  createFormState,
  required,
  hasLength,
  isProbablyEmail,
  onlyIntegers,
  validateWhen,
  includedIn,
} from 'redux-freeform';

const receiptFormConfig = {
  emailReceipt: {},
  emailAddress: {
    validators: [
      // includedIn[true] will only apply validation if the related checkbox field is checked (true)
      validateWhen(required(), includedIn([true]), 'emailReceipt'),
      validateWhen(isProbablyEmail(), includedIn([true]), 'emailReceipt'),
      ,
    ],
  },
  textReceipt: {},
  phoneNumber: {
    validators: [
      // includedIn[true] will only apply validation if the related checkbox field is checked (true)
      validateWhen(required(), includedIn([true]), 'textReceipt'),
      validateWhen(hasLength(10, 10), includedIn([true]), 'textReceipt'),
    ],
    constraints: [hasLength(0, 10), onlyIntegers()],
  },
};

export const { reducer, mapStateToProps, mapDispatchToProps } =
  createFormState(receiptFormConfig);
